// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3MAnU","item":"PaymentsMobile_item__1Of9N","label":"PaymentsMobile_label__1pNcK","amount":"PaymentsMobile_amount__21Hzj"};